import axios, { AxiosRequestConfig } from 'axios';

import { getWPApiHost } from '@/helpers/backend';

export const wpApiInstance = axios.create({
  baseURL: getWPApiHost(),
});

export default {
  async get<RequestEntity>(url: string, config: AxiosRequestConfig = {}) {
    return wpApiInstance.get<RequestEntity>(url, config);
  },
};
